import React from "react";
import _ from "lodash";
import moment from "moment";

import ParkerStatusTableDataRow from "./ParkerStatusTableDataRow";
import ParkerStatusTableAddRow from "./ParkerStatusTableAddRow";

import {
  queryCreateParkerStatusHistory,
  queryUpdateParkerStatusHistory,
  queryDeleteParkerStatusHistory,
} from "../../Queries/Parker";

import "./ParkerStatus.scss";

const parkerStatusHistory = [
  "id",
  "parker_id",
  "action",
  "start_date",
  "end_date",
  "notes",
];

const updateParkerStatusHistory = [
  "id",
  "parker_id",
  "action",
  "start_date",
  "end_date",
  "notes",
  "created_at",
];

const deleteParkerStatusHistory = ["delete_status"];

class ParkerStatusTable extends React.Component {
  state = {
    initializationComplete: true,
    inputs: {
      selectedAction: "",
      selectedSuspensionStartDate: null,
      selectedSuspensionEndDate: null,
      isNoEndDate: false,
      terminationDate: null,
    },
    isAddMode: false,
    showErrors: false,
    editMode: false,
    showAccessStatus: false,
    reqError: "",
  };

  fieldConfiguration = null;

  handleInputChange = (inputId) => {
    return (value) => {
      if (inputId === "Inputs") {
        this.setState({
          inputs: {
            selectedAction: value.action,
            selectedSuspensionStartDate: value.start_date,
            selectedSuspensionEndDate: value.end_date,
            isNoEndDate: value.noEndDate,
            terminationDate: value.start_date,
          },
          reqError: "",
        });
      } else if (inputId === "selectedAction") {
        this.setState({
          inputs: {
            selectedAction: value,
            selectedSuspensionStartDate: null,
            selectedSuspensionEndDate: null,
            isNoEndDate: false,
            terminationDate: null,
          },
          reqError: "",
        });
      } else {
        const inputs = _.cloneDeep(this.state.inputs);
        inputs[inputId] = value;
        this.setState({ inputs, reqError: "" });
      }
    };
  };

  handleAddAddRow = () => {
    this.setState({ isAddMode: true });
  };

  handleCancelAddRow = () => {
    this.setState({
      inputs: {
        selectedAction: "",
        selectedSuspensionStartDate: null,
        selectedSuspensionEndDate: null,
        isNoEndDate: false,
        terminationDate: null,
      },
      isAddMode: false,
      showErrors: false,
      editMode: false,
      reqError: "",
    });
  };

  validateParkerStatus(inputs) {
    if (inputs.selectedAction === "TERMINATE") {
      if (inputs.terminationDate) {
        this.setState({
          showErrors: false,
        });

        return true;
      }

      this.setState({
        showErrors: true,
      });

      return false;
    }

    const validDates = moment(inputs.selectedSuspensionStartDate).isBefore(inputs.selectedSuspensionEndDate);
    if (inputs.selectedSuspensionStartDate) {
      if (!inputs.isNoEndDate && !validDates) {
        this.setState({
          showErrors: true,
        });

        return false;
      }

      if (!inputs.isNoEndDate) {
        if (inputs.selectedSuspensionEndDate) {
          this.setState({
            showErrors: false,
          });

          return true;
        } else {
          this.setState({
            showErrors: true,
          });

          return false;
        }
      } else {
        this.setState({
          showErrors: false,
        });

        return true;
      }
    } else {
      this.setState({
        showErrors: true,
      });

      return false;
    }
  }

  updateParkerStatus = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const parkerId = urlSearchParams.get("parker");

    if (this.validateParkerStatus(this.state.inputs)) {
      this.setState({
        parkerListQueryInProgress: true,
      });

      return new Promise((resolve, reject) => {
        const historyItem = this.props.statusHistory.find((i) => i.isEditable);

        const variables = {
          id: historyItem.id,
          parker_id: parkerId,
          action: historyItem.action,
          start_date: moment(historyItem.start_date).format("YYYY-MM-DD"),
          end_date: historyItem.end_date
            ? moment(historyItem.end_date).format("YYYY-MM-DD")
            : null,
          notes: historyItem.notes,
          timezone: moment.tz.guess(),
        };

        queryUpdateParkerStatusHistory(
          variables,
          updateParkerStatusHistory
        ).then(
          (response) => {
            if (response.errors) {
              reject(response.errors.map((error) => error.message));
              this.setState({
                reqError: response.errors[0].message,
              });
              return;
            }

            this.setState({
              inputs: {
                parkerListQueryInProgress: false,
                selectedAction: "",
                selectedSuspensionStartDate: null,
                selectedSuspensionEndDate: null,
                isNoEndDate: false,
                terminationDate: null,
              },
              isAddMode: false,
              showErrors: false,
              editMode: false,
            });

            this.props.fetchParker(parkerId);
            this.props.onEditDone();
            resolve();
          },
          (error) => {
            this.setState({
              parkerListQueryInProgress: false,
            });
            reject([error]);
          }
        );
      });
    }
  };

  deleteParkerStatus = (id) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const parkerId = urlSearchParams.get("parker");

    this.setState({
      parkerListQueryInProgress: true,
    });

    return new Promise((resolve, reject) => {
      const variables = { id };

      queryDeleteParkerStatusHistory(variables, deleteParkerStatusHistory).then(
        (response) => {
          if (response.errors) {
            reject(response.errors.map((error) => error.message));
            return;
          }

          this.props.fetchParker(parkerId);
          resolve();
        },
        (error) => {
          this.setState({
            parkerListQueryInProgress: false,
          });
          reject([error]);
        }
      );
    });
  };

  saveParkerStatus = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const parkerId = urlSearchParams.get("parker");

    const { inputs } = this.state;
    if (this.validateParkerStatus(inputs)) {
      this.setState({
        parkerListQueryInProgress: true,
      });

      return new Promise((resolve, reject) => {
        const startDate =
          inputs.selectedAction === "TERMINATE"
            ? moment(inputs.terminationDate).add(1, "day").format("YYYY-MM-DD")
            : moment(inputs.selectedSuspensionStartDate).format("YYYY-MM-DD");

        const variables = {
          parker_id: this.props.parker.id.value,
          action: inputs.selectedAction,
          start_date: startDate,
          end_date: inputs.selectedSuspensionEndDate
            ? moment(inputs.selectedSuspensionEndDate).format("YYYY-MM-DD")
            : null,
          notes: inputs.notes,
          timezone: moment.tz.guess(),
        };

        queryCreateParkerStatusHistory(variables, parkerStatusHistory).then(
          (response) => {
            if (response.errors) {
              reject(response.errors.map((error) => error.message));
              this.setState({
                reqError: response.errors[0].message,
              });
              return;
            }

            this.setState({
              inputs: {
                parkerListQueryInProgress: false,
                selectedAction: "",
                selectedSuspensionStartDate: null,
                selectedSuspensionEndDate: null,
                isNoEndDate: false,
                terminationDate: null,
              },
              isAddMode: false,
              showErrors: false,
              editMode: false,
            });
            this.props.fetchParker(parkerId);
            resolve();
          },
          (error) => {
            this.setState({
              parkerListQueryInProgress: false,
            });
            reject([error]);
          }
        );
      });
    }
  };

  getDates = (type) => {
    const { billing_day } = this.props?.billingProfile;
    const dates = [];

    let startDate =
      new Date().getDate() < billing_day
        ? moment().add(1, "month").format("YYYY-MM-DD")
        : moment().add(2, "month").format("YYYY-MM-DD");

    for (let i = 0; i < 18; i++) {
      const date = moment(startDate).format("YYYY-MM-DD");
      const currentDate = new Date(date);
      const firstOfMonth = moment(
        new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
      );
      const lastOfMonth = moment(
        new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
      );

      dates.push({
        label:
          type === "startDate"
            ? firstOfMonth.format("ll")
            : lastOfMonth.format("ll"),
        value:
          type === "startDate"
            ? firstOfMonth.format("YYYY-MM-DD")
            : lastOfMonth.format("YYYY-MM-DD"),
      });

      startDate = moment(startDate).add(1, "month").format("YYYY-MM-DD");
    }

    if (type === "startDate") {
      dates.unshift({
        label: "Suspend Now",
        value: moment().format("YYYY-MM-DD"),
      });
    } else if (
      type === "endDate" &&
      this.state.inputs.selectedSuspensionStartDate ===
        moment().format("YYYY-MM-DD")
    ) {
      dates.unshift({
        label: moment().endOf("month").format("ll"),
        value: moment().endOf("month").format("YYYY-MM-DD"),
      });
    }

    dates.unshift({ value: null, label: "" });
    return dates;
  };

  _onEntryChange(ident) {
    return (value) => {
      this.props.onEntryChange(ident, value);
    };
  }

  render() {
    const {
      initializationComplete,
      isAddMode,
      inputs,
      showErrors,
      editMode,
      showAccessStatus,
      reqError,
    } = this.state;

    const { parker, statusHistory, fieldConfiguration, billingProfile } = this.props;

    const terminationStatus = parker.termination_status.value === "TERMINATED";

    return (
      <div className="parkerstatus-line-item-entry-table">
        {!initializationComplete && <p>Please wait...</p>}
        {initializationComplete && (
          <React.Fragment>
            <header className="parkerstatus-line-item-entry-table--header">
              <div className="parkerstatus-line-item-entry-table--row">
                <div className="parkerstatus-line-item-entry-table--date-recorded-column parkerstatus-line-item-entry-table--cell">
                  <span className="parkerstatus-line-item-entry-table--column-heading">
                    Date Recorded
                  </span>
                </div>
                <div className="parkerstatus-line-item-entry-table--action-column parkerstatus-line-item-entry-table--cell">
                  <span className="parkerstatus-line-item-entry-table--column-heading">
                    Action
                  </span>
                </div>
                <div className="parkerstatus-line-item-entry-table--parker-start-date-column parkerstatus-line-item-entry-table--cell">
                  <span className="parkerstatus-line-item-entry-table--column-heading">
                    Start Date
                  </span>
                </div>
                {showAccessStatus && (
                  <div className="parkerstatus-line-item-entry-table--access-status-column parkerstatus-line-item-entry-table--cell">
                    <span className="parkerstatus-line-item-entry-table--column-heading">
                      Access Status
                    </span>
                  </div>
                )}
                <div className="parkerstatus-line-item-entry-table--sus-start-date-column parkerstatus-line-item-entry-table--cell">
                  <span className="parkerstatus-line-item-entry-table--column-heading">
                    Suspension Start Date
                  </span>
                </div>
                <div className="parkerstatus-line-item-entry-table--sus-end-date-column parkerstatus-line-item-entry-table--cell">
                  <span className="parkerstatus-line-item-entry-table--column-heading">
                    Suspension End Date
                  </span>
                </div>
                <div className="parkerstatus-line-item-entry-table--no-end-date-column parkerstatus-line-item-entry-table--cell">
                  <span className="parkerstatus-line-item-entry-table--column-heading">
                    No End Date
                  </span>
                </div>
                <div className="parkerstatus-line-item-entry-table--termination-date-column parkerstatus-line-item-entry-table--cell">
                  <span className="parkerstatus-line-item-entry-table--column-heading">
                    Termination Date
                  </span>
                </div>
                <div className="parkerstatus-line-item-entry-table--notes-column parkerstatus-line-item-entry-table--cell">
                  <span className="parkerstatus-line-item-entry-table--column-heading">
                    Notes
                  </span>
                </div>
                <div className="parkerstatus-line-item-entry-table--action-column parkerstatus-line-item-entry-table--cell">
                  <span className="parkerstatus-line-item-entry-table--column-heading"></span>
                </div>
              </div>
            </header>
            <div className="parkerstatus-line-item-entry-table--body">
              <div className="parkerstatus-line-item-entry-table--row">
                {statusHistory &&
                  statusHistory?.map((historyItem, ident) => (
                    <ParkerStatusTableDataRow
                      parker={parker}
                      historyItem={historyItem}
                      editMode={editMode}
                      isAddMode={isAddMode}
                      showErrors={showErrors}
                      reqError={reqError}
                      handleEdit={() => {
                        this.setState({ editMode: true });
                        this.props.onEdit(ident);
                      }}
                      handleDelete={this.deleteParkerStatus}
                      onChange={this._onEntryChange(ident)}
                      handleChange={this.handleInputChange}
                      getDates={this.getDates}
                      showAccessStatus={showAccessStatus}
                      fieldConfiguration={fieldConfiguration}
                    />
                  ))}

                {isAddMode && (
                  <ParkerStatusTableAddRow
                    billingProfile={billingProfile}
                    showErrors={showErrors}
                    reqError={reqError}
                    inputs={inputs}
                    onChange={this.handleInputChange}
                    getDates={this.getDates}
                    parker={parker}
                    fieldConfiguration={fieldConfiguration}
                    showAccessStatus={showAccessStatus}
                  />
                )}
              </div>
            </div>
            {!terminationStatus && (
              <footer className="parkerstatus-line-item-entry-table--header">
                <div className="parkerstatus-line-item-entry-table--row">
                  {!isAddMode && !editMode ?
                    <button
                      className="parkerstatus--add-new-action"
                      onClick={this.handleAddAddRow}
                    >
                      <span>Add New Action</span>
                    </button>
                    :
                    <div className="parkerstatus-actions">
                      <button
                        className="parkchirp--button-as-link"
                        onClick={() => {
                          this.handleCancelAddRow();
                          editMode && this.props.onCancelClick();
                        }}
                      >
                        <span>Cancel</span>
                      </button>
                      <button
                        className="button button-primary"
                        onClick={() => {
                          editMode
                            ? this.updateParkerStatus()
                            : this.saveParkerStatus();
                        }}
                        disabled={!editMode ? !inputs.selectedAction : false}
                      >
                        <span>{editMode ? "Update" : "Save"}</span>
                      </button>
                    </div>
                  }
                </div>
              </footer>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default ParkerStatusTable;
